import React from 'react';
import { FileText, Phone, Video, Mail, ListChecks } from 'lucide-react';

export const ACTIVITY_TYPES = [
  { value: 'note', label: 'Note', icon: FileText, color: 'blue' },
  { value: 'call', label: 'Call', icon: Phone, color: 'green' },
  { value: 'meeting', label: 'Meeting', icon: Video, color: 'purple' },
  { value: 'email', label: 'Email', icon: Mail, color: 'yellow' },
  { value: 'task', label: 'Task', icon: ListChecks, color: 'red' },
];

export const getActivityTypeConfig = (type) => {
  return ACTIVITY_TYPES.find(t => t.value === type) || ACTIVITY_TYPES[0];
};

function ActivityTypeSelector({ value, onChange }) {
  return (
    <div className="flex gap-1.5 flex-wrap">
      {ACTIVITY_TYPES.map((type) => {
        const IconComponent = type.icon;
        const isActive = value === type.value;

        return (
          <button
            key={type.value}
            type="button"
            onClick={() => onChange(type.value)}
            className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm border transition-all duration-150 ${
              isActive
                ? 'bg-brand-50 border-brand-200 text-brand-700 font-medium shadow-sm'
                : 'bg-white border-gray-200 text-gray-500 font-normal hover:bg-gray-50 hover:text-gray-600 hover:border-gray-300'
            }`}
            aria-pressed={isActive}
            aria-label={`Select ${type.label} activity type`}
          >
            <IconComponent className="w-3.5 h-3.5" strokeWidth={2} />
            {type.label}
          </button>
        );
      })}
    </div>
  );
}

export default ActivityTypeSelector;
